// extracted by mini-css-extract-plugin
export var legendIndicator = "_bj-1";
export var legendRight = "_bj-0";